import { h } from 'preact';
import { Router } from 'preact-router';

import ChatAds from 'containers/ChatAds';
import LandingPage from 'containers/LandingPage';
import LanguageProvider from 'containers/LanguageProvider';
import WarisAds from 'containers/WarisAds';
import WarisCalculator from 'containers/WarisCalculator';
import WasiatAds from 'containers/WasiatAds';
import Template from 'containers/Template';

const App = (messages) => (
  <div id="app">
    <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700;900&family=Open+Sans:wght@400;700&display=swap" rel="stylesheet"></link>

    <LanguageProvider messages={messages}>
      <Router>
        <LandingPage path="/" />
        <ChatAds path="/chat" />
        <ChatAds path="/phonecall" />
        <WarisAds path="/HakWaris" />
        <WarisCalculator path="/KalkulatorWaris" />
        <WasiatAds path="/Wasiat" />
        <Template path="/Template" />
      </Router>
    </LanguageProvider>
  </div>
)

export default App;
